var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_54",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("g", { attrs: { id: "Layer_55" } }, [
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            d: "m29.487,45.239c3.759,9.854,6.573,20.251,10.164,30.201.384,1.063,1.079,2,1.978,2.684,1.683,1.281,3.943,1.838,6.008,2.097,2.232.28,4.519.122,6.69-.466.912-.247,1.806-.567,2.671-.946,1.437-.63,2.572-1.867,3.104-3.343,3.591-9.95,6.405-20.347,10.164-30.201",
          },
        }),
      ]),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m48.468,88.655h8.821c1.559,0,3-.833,3.779-2.184h0c.786-1.364.52-3.092-.641-4.156h0c-1.271-1.165-2.028-1.866-2.107-3.588v-.92",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m51.313,88.655h-8.821c-1.559,0-3-.833-3.779-2.184h0c-.786-1.364-.52-3.092.641-4.156h0c1.271-1.165,2.028-1.866,2.107-3.588v-.92",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "32.83", y1: "52.584", x2: "66.924", y2: "52.584" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "51.992 68.44 56.041 39.214 62.974 38.145" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }